import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import * as yup from "yup";

import { Button } from "./ui/button";
import useFirebaseGlassData from "../hooks/useFirebaseGlassData";
import { getGlassDataDropdownOptionsFromInventory, glasstypes } from "../helpers/glassHelpers";

import {
  HookInput as Input,
  HookDropdown as Dropdown,
  HookSelect as Select,
} from "../helpers/formHelpers";

const InlineMaterialForm = ({ initialValues, onSubmit }: { initialValues: any; onSubmit: any }) => {
  const schema = yup.object().shape({
    glass_type: yup.string().required(),
    count: yup.number().required().positive().integer(),
  });

  const { control, handleSubmit, formState, watch, reset } = useForm({
    resolver: yupResolver(schema),
    defaultValues: initialValues,
  });
  const { errors } = formState;
  useEffect(() => {
    reset(initialValues);
  }, [initialValues, reset]);

  const glass_type = watch("glass_type", initialValues.glass_type);
  const glass_data = useFirebaseGlassData(glass_type);
  const options = getGlassDataDropdownOptionsFromInventory(glass_data?.inventory);
  const added_glasstypes = [...glasstypes, { label: "Other", value: "Other" }];
  const dropdown_enabled = glass_type === "Spectrum" || glass_type === "Bullseye";
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Select
          control={control}
          errors={errors}
          name="glass_type"
          label="Manufacturer"
          defaultValue={initialValues.manufacturer}
          items={added_glasstypes}
        />
        <Input control={control} errors={errors} name="description" label="Description" />
        {dropdown_enabled && (
          <Dropdown
            control={control}
            errors={errors}
            name="glass_reference"
            label={`${glass_type} Glass Reference`}
            defaultValue={initialValues.glass_reference}
            search
            clearable
            options={options}
            placeholder={`Select a ${glass_type} item`}
          />
        )}
        <Input
          control={control}
          errors={errors}
          name="count"
          label="Number of Items"
          defaultValue={initialValues.count}
        />

        <Button
          variant="outline"
          onClick={handleSubmit(onSubmit)}
          disabled={!formState.isDirty || formState.isSubmitting}
        >
          {initialValues.id ? "Edit" : "Add"}
        </Button>
      </form>
    </div>
  );
};

export default InlineMaterialForm;
